import axios from 'axios';

const AxiosInterceptor = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL_MOMTHERA,
	// timeout: 15000,
});

// request interceptors
AxiosInterceptor.interceptors.request.use(
	config => {
		const tokenData = localStorage.getItem('dtx006token');
		if (!tokenData) {
			// 토큰이 없으면 Authorization 없이 진행 (백엔드 401 유도)
			return config;
		}
		const parsed = JSON.parse(tokenData);
		if (parsed?.accessToken) {
			config.headers.Authorization = `Bearer ${parsed.accessToken}`;
		}

		return config;
	},
	error => {
		return Promise.reject(error);
	},
);

let isTokenRefreshing = false;
let refreshSubscribers = [];

const onTokenRefreshed = accessToken => {
	// eslint-disable-next-line array-callback-return
	refreshSubscribers.map(callback => {
		callback(accessToken);
	});

	refreshSubscribers = [];
};

const addRefreshSubscriber = callback => {
	refreshSubscribers.push(callback);
};

AxiosInterceptor.interceptors.response.use(
	response => {
		return response;
	},
	async error => {
		if (error.response && error.response.status === 401) {
			const originalRequest = error.config;
			if (isTokenRefreshing === false) {
				isTokenRefreshing = true;
				const tokenData = localStorage.getItem('dtx006token');
				if (!tokenData) {
					// 토큰이 전혀 없으면 재시도 없이 리다이렉트
					sessionStorage.removeItem('hasShownLoginToast');
					window.location.replace('/sign-in/dtx006');
					return Promise.reject(error);
				}
				const { refreshToken } = JSON.parse(tokenData) || {};
				// refreshToken이 없거나 accessToken과 동일한 경우에는 리프레시 시도하지 않고 로그인 페이지로 튕김
				if (!refreshToken) {
					isTokenRefreshing = false;
					localStorage.removeItem('dtx006token');
					sessionStorage.removeItem('hasShownLoginToast');
					window.location.replace('/sign-in/dtx006');
					return Promise.reject(error);
				}
				// token refresh 요청
				try {
					const resp = await axios.post(
						`${process.env.REACT_APP_AUTH_URL}/auth/token/refresh`,
						null,
						{
							params: { refreshToken },
							headers: {
								Authorization: null,
							},
						},
					);

					// 새로운 토큰 저장
					if (parseInt(resp.status / 200, 10) === 1) {
						localStorage.setItem('dtx006token', JSON.stringify(resp.data));

						// refresh 상태 해제
						isTokenRefreshing = false;

						originalRequest.headers.Authorization = `Bearer ${resp.data.accessToken}`;

						// 401로 실패했던 요청을 새로운 accessToken으로 재요청
						onTokenRefreshed(resp.data.accessToken);
						return AxiosInterceptor(originalRequest);
					} else {
						throw new Error('token refresh error');
					}
				} catch (e) {
					console.log(e);
					isTokenRefreshing = false;
					// refresh 실패 시 로그인 페이지로 이동 (잘못된/만료 토큰)
					localStorage.removeItem('dtx006token');
					sessionStorage.removeItem('hasShownLoginToast');
					window.location.replace('/sign-in/dtx006');
					return Promise.reject(e);
				}
			}
			const retryOriginalRequest = new Promise(resolve => {
				addRefreshSubscriber(accessToken => {
					originalRequest.headers.Authorization = `Bearer ${accessToken}`;
					resolve(AxiosInterceptor(originalRequest));
				});
			});
			return retryOriginalRequest;
		}
		return error;
	},
);

export default AxiosInterceptor;
